// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3Jwkb","modalForm":"UpgradeEpcsModal_modalForm__A7jEG","modalFooter":"UpgradeEpcsModal_modalFooter__1XZkd"};